import React, { useRef, useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { PriceContext } from '../../contexts/PriceContext';
import SelectedAccessories from '../accessoriesList/SelectedAccessories';
import AccessoriesList from '../accessoriesList/AccessoriesList';
import SummaryBar from '../SummaryBar';
import { ToastContainer } from 'react-toastify';
import PopUpButton from '../popup/PopUpButton';
import PopUp from '../popup/PopUp';
import RodsInfo from '../popup/RodsInfo';
import DeleteAccessoriesPopup from '../popup/DeleteAccessoriesPopup';
import AccessoriesInfoPopup from '../popup/AccessoriesInfoPopup';
import { createAccessoriesList, Wardrobe } from '../accessoriesList/accessories.service';
import {
  useDedicatedAccessories,
  useCheckWardrobe,
} from '../accessoriesList/_hooks/dedicated.hooks';
import calculatePrice from '../../helpers/calculatePrice';
import { reactLocalStorage } from 'reactjs-localstorage';
import { useHistory } from 'react-router-dom';
import Loader from '../Loader';
import 'react-toastify/dist/ReactToastify.css';

const CloseButtonHeader = ({ onClick }) => (
  <div className="pop-up__header">
    <div onClick={onClick} className="pop-up__header-button">
      Zamknij akcesoria <span className="icon__remove"></span>
    </div>
  </div>
);

CloseButtonHeader.propTypes = {
  onClick: PropTypes.func,
};

function AccessoriesConfig({
  addonsList,
  activeWardrobe,
  accessories,
  activeZone,
  dedicatedAccessories,
}) {
  const setDedicatedAccessories = useDedicatedAccessories();
  const wardrobeState = useCheckWardrobe();
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const [wasErased, setErasedList] = useState(false);
  const [externalLights, setExternalLights] = useState(
    wardrobesConfigs[activeWardrobe].external_light,
  );
  const [popupVisibility, setPopUp] = useState(false);
  const { setPrice } = useContext(PriceContext);

  const dedicatedList = dedicatedAccessories.list;
  const showDedicated = !wardrobeState.hasAccessories && !wasErased;
  const loadDedicated =
    dedicatedList.left.length > 0 ||
    dedicatedList.center.length > 0 ||
    dedicatedList.right.length > 0;
  const history = useHistory();

  const updateWardrobeConfig = data => {
    const updatedConfig = [...wardrobesConfigs];
    updatedConfig[activeWardrobe].accessories[activeZone] = data;
    setWardrobesConfigs(updatedConfig);
    setErasedList(true);
  };
  const openPopup = popupName => {
    const popup = document.querySelector(`[data-popup-name="${popupName}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  useEffect(() => {
    const changeZone = e => {
      if (e.target.tagName === 'CANVAS') {
        closePopup();
      }
    };

    document.addEventListener('mousedown', changeZone);
    return () => {
      document.removeEventListener('mousedown', changeZone);
    };
  }, []);

  const accessoriesConfigRef = useRef();
  let checkListHeight;
  const ActiveWardrobe = new Wardrobe(
    wardrobesConfigs[activeWardrobe],
    activeZone,
    updateWardrobeConfig,
  );

  const selectedItems = ActiveWardrobe.accessories.list;
  const updateList = ActiveWardrobe.update;
  const availableSpace = ActiveWardrobe.availableSpace;

  const list = createAccessoriesList(accessories, selectedItems).filter(
    el => el.side === activeZone,
  );

  const closePopup = () => {
    setPopUp(false);
  };

  const cleanAccessories = () => {
    let wardrobe = [...wardrobesConfigs];
    wardrobe[activeWardrobe].accessories = {
      left: [],
      center: [],
      right: [],
    };
    setWardrobesConfigs(wardrobe);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
    setErasedList(true);
  };

  const removeEntryAccessLS = () => {
    reactLocalStorage.remove('entryAccessories');
    history.push('/summary');
  };

  const assignExternalLights = isChecked => {
    let wardrobe = [...wardrobesConfigs];
    setExternalLights(isChecked);

    wardrobe[activeWardrobe].external_light = isChecked;

    wardrobe[activeWardrobe].addons.external_light = isChecked
      ? addonsList.find(item => item.safo.includes('L99-PST'))
      : null;
    setWardrobesConfigs(wardrobesConfigs);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  if (accessoriesConfigRef.current !== undefined) {
    checkListHeight = accessoriesConfigRef.current.offsetHeight;
  }

  return (
    <div>
      <div className="head-title">
        <p className="accessories-config__instruction title">Wybierz strefę</p>
        <p className="accessories-config__instruction">w której chcesz dodać akcesoria</p>
      </div>
      <div className="accessories">
        {popupVisibility && (
          <div className="accessories__header--desktop">
            <CloseButtonHeader onClick={closePopup} />
          </div>
        )}
        {list.length > 0 ? (
          <div className="pop-up__button--position">
            <button className="pop-up__button" onClick={() => setPopUp(true)}>
              <span className="icon-plus" />
            </button>
            <p className="pop-up__title">Dodaj akcesoria</p>
          </div>
        ) : (
          <p className="accessories__info">W tej strefie nie można dodać żadnych akcesoriów</p>
        )}
        <div
          className={`accessories-config ${
            checkListHeight >= 350 ? 'accessories-config--scroll' : ''
          }`}
          ref={accessoriesConfigRef}>
          <SelectedAccessories accessories={selectedItems} wardrobe={ActiveWardrobe} />
        </div>
        <div
          className={`pop-up pop-up--accessories pop-up--background ${
            popupVisibility ? 'open' : ''
          }`}>
          <div className="pop-up__container">
            <CloseButtonHeader onClick={closePopup} />
            <AccessoriesList
              wardrobe={ActiveWardrobe}
              selectedItems={selectedItems}
              accessories={list}
              updateList={updateList}
              availableSpace={availableSpace}
              allAccessories={accessories}
            />
          </div>
        </div>
        <SummaryBar
          btnText={!popupVisibility ? 'Gotowe' : 'Dodaj'}
          btnFunction={popupVisibility ? closePopup : removeEntryAccessLS}
        />
      </div>
      <div className="button-position" onClick={() => openPopup('delete-accessories-popup')}>
        <button className="button-circle">
          <span className="icon-trash" />
        </button>
        <p className="pop-up__title">Wyczyść akcesoria</p>
      </div>
      <PopUp title=" " popupName="delete-accessories-popup" buttonText="Anuluj">
        <DeleteAccessoriesPopup cleanAccessories={cleanAccessories} />
      </PopUp>

      <PopUp title="Informacje na temat drążków" popupName="rods-info">
        <RodsInfo />
      </PopUp>
      {showDedicated &&
        (!!loadDedicated ? (
          <PopUp title="" popupName="accessories-info-popup" show>
            <AccessoriesInfoPopup
              setEntryPopup={() => {
                setDedicatedAccessories(dedicatedAccessories);
              }}
              setPrice={() => setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]))}
            />
          </PopUp>
        ) : (
          <Loader />
        ))}
      {ActiveWardrobe.wardrobe.dimensions.x > 100 && !ActiveWardrobe.wardrobe.is_corner && (
        <>
          <div className="accessories__check-button accessories__check-button--external-light">
            <button
              disabled={false}
              onClick={() => assignExternalLights(!externalLights)}
              className={`accessories-list__check-button ${externalLights ? 'active' : ''} ${
                !externalLights ? 'display' : ''
              }`}>
              <span className="icon-checkmark" />
            </button>
            <p>Oświetlenie zewnętrzne</p>
          </div>
        </>
      )}
      <PopUpButton
        icon="help-circle"
        text="Informacje na temat drążków"
        popupName="rods-info"
        propClass="button-mobile-display rods-info"
      />
      <ToastContainer />
    </div>
  );
}

export default AccessoriesConfig;
